import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MoonStar, ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { i18n } = useTranslation();
  const isZh = i18n.language.startsWith('zh');

  const explore = [
    ['/reading', isZh ? '在线占卜' : 'Tarot reading'],
    ['/library', isZh ? '78 张牌义' : '78-card library'],
    ['/journal', isZh ? '历史解读' : 'Reading history'],
    ['/learning', isZh ? '入门学习' : 'Learn tarot'],
    ['/pricing', isZh ? '价格方案' : 'Pricing'],
  ];
  const trust = [
    ['/about', isZh ? '关于我们' : 'About'],
    ['/faq', isZh ? '常见问题' : 'FAQ'],
    ['/disclaimer', isZh ? '使用说明' : 'Reading disclaimer'],
    ['/privacy', isZh ? '隐私政策' : 'Privacy'],
    ['/terms', isZh ? '服务条款' : 'Terms'],
    ['/contact', isZh ? '联系' : 'Contact'],
  ];

  return (
    <footer className="relative z-10 mt-24 border-t border-white/10 bg-tarot-ink/80">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <Link to="/" className="inline-flex items-center gap-3 text-tarot-starLight">
              <MoonStar className="h-6 w-6 text-tarot-gold" aria-hidden="true" />
              <span className="font-mystical text-xl">{isZh ? '塔罗奥秘' : 'Tarot Mystique'}</span>
            </Link>
            <p className="mt-5 max-w-md text-sm leading-7 text-tarot-starLight/65">
              {isZh ? '一个安静、私密的自我探索空间。塔罗在这里是一面镜子，而不是替你做决定的预言。' : 'A quiet, private space for self-reflection. Here, tarot is a mirror for your thinking—not a prediction that makes decisions for you.'}
            </p>
            <div className="mt-5 flex flex-wrap gap-x-5 gap-y-2 text-xs text-tarot-starLight/50">
              <span className="inline-flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-tarot-sage" />{isZh ? '免费练习无需注册；购买需要账户' : 'Free practice needs no account; purchases need one'}</span>
              <span className="inline-flex items-center gap-2"><Mail className="h-4 w-4 text-tarot-sage" />{isZh ? '不出售个人数据' : 'We do not sell personal data'}</span>
            </div>
          </div>
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-tarot-gold">{isZh ? '探索' : 'Explore'}</h2>
            <ul className="mt-5 space-y-3 text-sm text-tarot-starLight/65">
              {explore.map(([href, label]) => <li key={href}><Link to={href} className="hover:text-tarot-starLight">{label}</Link></li>)}
            </ul>
          </div>
          <div>
            <h2 className="text-sm font-semibold uppercase tracking-[0.18em] text-tarot-gold">{isZh ? '信任与支持' : 'Trust & support'}</h2>
            <ul className="mt-5 space-y-3 text-sm text-tarot-starLight/65">
              {trust.map(([href, label]) => <li key={href}><Link to={href} className="hover:text-tarot-starLight">{label}</Link></li>)}
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs leading-5 text-tarot-starLight/50 md:flex-row md:items-center md:justify-between">
          <span>{isZh ? `© ${new Date().getFullYear()} 塔罗奥秘 · Celestria Studio 品牌，由 Triton Universal Technology LLC 运营。` : `© ${new Date().getFullYear()} Tarot Mystique · A Celestria Studio brand operated by Triton Universal Technology LLC.`}</span>
          <span>{isZh ? '内容仅用于娱乐与自我反思，不构成医疗、法律、心理或财务建议。' : 'For entertainment and reflection only—not medical, legal, mental-health, or financial advice.'}</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
